import { render, staticRenderFns } from "./L10n.vue?vue&type=template&id=65c7af90"
import script from "./L10n.vue?vue&type=script&lang=js"
export * from "./L10n.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports